import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import { navigationConfig } from '../../../config/navigation';
import styles from './Sidebar.module.css';

const Sidebar = ({ 
  isCollapsed, 
  onToggleCollapse,
  children 
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <aside className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ''}`}>
      <div className={styles.sidebarHeader}>
        <h4 className={styles.sidebarTitle}>MENU</h4>
        <button 
          className={styles.collapseBtn} 
          onClick={onToggleCollapse}
          aria-label={isCollapsed ? "Expandir menu lateral" : "Recolher menu lateral"}
          aria-expanded={!isCollapsed}
          aria-controls="sidebar-nav"
          title={isCollapsed ? "Expandir menu" : "Recolher menu"}
        >
          <i className={`fas ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
        </button>
      </div>

      <nav className={styles.sidebarNav} id="sidebar-nav">
        {navigationConfig.map((item) => (
          <button
            key={item.id}
            className={`${styles.navItem} ${location.pathname === item.path ? styles.active : ''}`}
            onClick={() => handleNavigation(item.path)}
          >
            <i className={`fas ${item.icon}`}></i>
            <span className={styles.navItemText}>{item.label}</span>
          </button>
        ))}
      </nav>

      {children && (
        <div className={styles.sidebarContent}>
          {children}
        </div>
      )}
    </aside>
  );
};

Sidebar.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onToggleCollapse: PropTypes.func.isRequired,
  children: PropTypes.node
};

export default Sidebar;
